import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetApplicationDiscountDetailsRequestObjectType,
  GetApplicationDiscountDetailsResponseType
} from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseGetApplicationDiscountDetailsInterface {
  getApplicationDiscountDetailsApi: UseMutateAsyncFunction<
    GetApplicationDiscountDetailsResponseType,
    Error,
    GetApplicationDiscountDetailsRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetApplicationDiscountDetailsApi =
  (): UseGetApplicationDiscountDetailsInterface => {
    const { nwApplicationService } = useNwApplicationService();

    const getApplicationDiscountDetails = (
      requestObject: GetApplicationDiscountDetailsRequestObjectType
    ) => {
      return nwApplicationService.getApplicationDiscountDetails(requestObject);
    };

    const { mutateAsync, error, status } = useMutation(
      getApplicationDiscountDetails,
      {
        mutationKey: ['getApplicationDiscountDetailsApi']
      }
    );

    const getApplicationDiscountDetailsApi = mutateAsync;

    return {
      getApplicationDiscountDetailsApi,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useGetApplicationDiscountDetailsApi };
